import "core-js/modules/es.array.index-of";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.trim";
export default (function (destination) {
  destination = (destination || '').trim();

  if (destination.indexOf('//') === 0 || destination.indexOf('http') === 0) {
    return '/';
  }

  return "/".concat(destination).replace(/^\/*/, '/');
});